import React, { memo, useMemo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { trackSettingsInteraction } from 'Pods/ThreeDStudio/Services/studioTracker'
import ToggleSelector from 'Pods/ThreeDStudio/Shared/ToggleSelector/ToggleSelector'
import { providerSupportsParam } from 'Pods/ThreeDStudio/Shared/Utils/providerSupportsParam'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setIsUnlimitedPolycount } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

const handleUnlimitedPolycountToggle = (isUnlimitedPolycount) => {
  trackSettingsInteraction('polycount_mode', isUnlimitedPolycount)
  setIsUnlimitedPolycount(isUnlimitedPolycount)
}

function UnlimitedPolycountSelector() {
  const t = useTranslation()
  const generationAction = useThreeDStudioStore(state => state.schema.generationAction)
  const generationProvider = useThreeDStudioStore(state => state.schema.generationProvider)
  const isSupported = useMemo(
    () => providerSupportsParam(generationAction, generationProvider, 'polycount_mode'),
    [generationAction, generationProvider],
  )

  if (!isSupported) {
    return null
  }

  return (
    <ToggleSelector
      id="model-settings-unlimited-polycount"
      keyName="isUnlimitedPolycount"
      label={t('leftSide.unlimitedPolycount.label')}
      setFunction={handleUnlimitedPolycountToggle}
      sliceName="modelSettings"
    />
  )
}

export default memo(UnlimitedPolycountSelector)
